import React from "react";
// tslint:disable-next-line: match-default-export-name
import GagoFlipNumbers from "@gago/react-flip-numbers";
// tslint:disable: variable-name
// tslint:disable: naming-convention
/**
 * 翻转数字牌简化组件
 * @author James Zhang
 * @param {*} props
 */
export const FlipNumbers = (props) => 
// tslint:disable-next-line: jsx-wrap-multiline
React.createElement(GagoFlipNumbers, Object.assign({}, props, { nonNumberStyle: Object.assign({ fontSize: props.height, color: props.color }, props.nonNumberStyle), numbers: props.children }));
FlipNumbers.defaultProps = {
    delayBetween: 0.05,
    duration: 2,
    loop: 1,
    play: true,
};
//# sourceMappingURL=index.js.map